import {
  FILTER_ON_ITEMS_CHECKED,
  ONLY_SHOW_ITEMS_CHECKED,
  ONLY_SHOW_ITEMS_WITH_CHECKED,
  FILTER_ON_IMPC_CHECKED,
  FILTER_ON_DESPATCH_CHECKED,
  MANUAL_ENTRY,
  SPACE_SEPERATED_SUFFIXES,
} from "../actions/types/ItemCriteriaTypes";
import filterItemCriteriaIfExistsInPostalOperators from "../filters/filterItemCriteriaIfExistsInPostalOperators";

export const initialState = {
  nodes: [],
  checkedFilterOnItems: [],
  checkedOnlyShowItems: [],
  checkedOnlyShowItemsWith: [],
  checkedFilterOnImpc: false,
  checkedFilterOnDespatch: false,
  manualEntryText: "",
  spaceSeparatedSuffixes: "",
};

export const itemCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_ON_ITEMS_CHECKED:
      return {
        ...state,
        checkedFilterOnItems: filterItemCriteriaIfExistsInPostalOperators(
          action.checkedItemCriteria,
          action.nodesItemCriteria
        ),
      };
    case ONLY_SHOW_ITEMS_CHECKED:
      return {
        ...state,
        checkedOnlyShowItems: filterItemCriteriaIfExistsInPostalOperators(
          action.checkedItemCriteria,
          action.nodesItemCriteria
        ),
      };
    case ONLY_SHOW_ITEMS_WITH_CHECKED:
      return {
        ...state,
        checkedOnlyShowItemsWith: filterItemCriteriaIfExistsInPostalOperators(
          action.checkedItemCriteria,
          action.nodesItemCriteria
        ),
      };
    case FILTER_ON_IMPC_CHECKED:
      return {
        ...state,
        checkedFilterOnImpc: action.status,
      };
    case FILTER_ON_DESPATCH_CHECKED:
      return {
        ...state,
        checkedFilterOnDespatch: action.status,
      };
    case MANUAL_ENTRY:
      return {
        ...state,
        manualEntryText: action.seperatedString,
      };
    case SPACE_SEPERATED_SUFFIXES:
      return {
        ...state,
        spaceSeparatedSuffixes: action.suffixText,
      };
    default:
      return state;
  }
};
